import { useContext } from "react";
import { useFormContext } from "react-hook-form";

import { Table, TableBody, TableContainer } from "@mui/material";

import { CafsValue } from "../../../../api/types/cafs";
import { PlantProduct } from "../../../../api/types/plants";
import { CafsVariable } from "../../../../types/cafs-variable";
import { useTooltips } from "../../api/useTooltips";
import { CafsContext } from "../../CafsContext";
import { CafsSection } from "../../const/cafs-section";
import { RenderProductTableRowFn } from "../../types/render-product-table-row-fn";
import { SaveBtn } from "../cafs-table/SaveBtn";

import { ProductTableHeader } from "./ProductTableHeader";

type ProductTableProps = {
  data: Partial<Record<keyof PlantProduct, CafsValue>>;
  rows: CafsVariable<PlantProduct>[];
  render: RenderProductTableRowFn<PlantProduct>;
  saveDisabled: boolean;
  productCode: string | undefined;
};

export function ProductTable({
  rows,
  render,
  data,
  saveDisabled,
  productCode,
}: ProductTableProps) {
  const methods = useFormContext();
  const { cafs, isReadMode } = useContext(CafsContext);
  const { tooltips } = useTooltips(data, CafsSection.PlantProduct);

  return (
    <>
      <TableContainer>
        <Table data-testid={`${CafsSection.PlantProduct}_table`}>
          <ProductTableHeader />
          <TableBody>
            {(rows || []).map(row =>
              row.shouldRender &&
              !row.shouldRender({ methods: methods, cafsType: cafs?.Type })
                ? null
                : render({
                    row: row,
                    data: data,
                    section: CafsSection.PlantProduct,
                    tooltips: tooltips,
                    isReadMode: isReadMode,
                    productCode: productCode,
                  }),
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="mt-8">
        <SaveBtn data-testid="save_section_btn" disabled={saveDisabled} />
      </div>
    </>
  );
}
